import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { BuildEnvironment } from "../../../environments/environment";
import { IFinancialInfo } from "../models/financialinfomation.model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class FinancialInformationService {
  private baseurl = BuildEnvironment.GetEnvironmentUrl() + "/myprofile";

  constructor(private http: HttpClient) {}

  getFinancialInfo(p_agencyID: number): Observable<IFinancialInfo> {
    try {
      return this.http.get<IFinancialInfo>(
        this.baseurl + "/financialinfo/" + p_agencyID
      );
    } catch (err) {
      console.log(
        "---------Unexpected error occured in Financial Info GET-------"
      );
    }
  }

  submitFinancialInfo(p_financialInfo: IFinancialInfo): Observable<any> {
    try {
      console.log("p_financialInfo: ", p_financialInfo);
      return this.http.post(this.baseurl + "/submitfinancialinfo", p_financialInfo);
    } catch (err) {
      console.log(
        "---------Unexpected error occured in Financial Info POST-------"
      );
    }
  }
}
